// @ts-check

export function finiteNumber(value, fallback = 0) {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : fallback;
}

export function normalizeAngleDeg(angleDeg = 0) {
  const normalized = finiteNumber(angleDeg, 0) % 360;
  return normalized < 0 ? normalized + 360 : normalized;
}

export function degToRad(deg = 0) {
  return finiteNumber(deg, 0) * Math.PI / 180;
}
